import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { API_URL } from 'src/app/config/api.constant';
import { map } from 'rxjs/operators';
import * as Config from 'src/app/config/app.constant';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http: HttpClient) { }

  public checkWarning(param: any) {
    return this.http.post(`${API_URL.checkWarning}`, param).pipe(map((res) => res));
  }

  public getHospital() {
    return this.http.get(`${API_URL.getHospital}`, Config.HTTP_OPTIONS_SMARTCLAIM).pipe(map((res) => res));
  }

  private checkPassword = new BehaviorSubject('');
  expPass = this.checkPassword.asObservable();


  expirePassword(data: string) {
    this.checkPassword.next(data);
  }

}
